import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {Pill} from '../../../../components/pill/pill';

/*
 * Style.
 */

const StyledPill = styled(Pill)`
  border-radius: 100px;
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledLabelDiv = styled.div`
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.semibold};
  padding: 2px 0 2px 0;
`;

/*
 * Component.
 */

export const UpsellPill: FC<PropsWithChildren<unknown>> = (props) => {
  const theme = useUserTheme();

  return (
    <StyledPill
      color={theme.greys.white}
      backgroundColor={theme.palette.yellow.shade40}
      size={VisualSizesEnum.MEDIUM}
    >
      <StyledLabelDiv>{props.children}</StyledLabelDiv>
    </StyledPill>
  );
};
